import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AlertController, LoadingController } from "@ionic/angular";
import { STORAGE } from "../../../constant/storages";
import { ApiserviceService } from "../../../httpservice/apiservice.service";
import { errMsg } from "../../../text_control/error-msg";
import { BTN } from "../../../text_control/text_button";
import { _getStorage, _setStorage } from "../../../utils/local-storage";

@Component({
  selector: "app-log-etax",
  templateUrl: "./log-etax.component.html",
  styleUrls: ["./log-etax.component.scss"],
})
export class LogEtaxComponent implements OnInit {
  Active = 3;
  caseId = "";

  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";
  userSource = "";

  constructor(
    public router: Router,
    private apiService: ApiserviceService,
    public loadingController: LoadingController,
    private alert: AlertController
  ) {}

  ngOnInit() {}
  ionViewDidEnter() {
    this.userID = _getStorage(STORAGE.userID);
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    this.userSource = _getStorage(STORAGE.SOURCE_SYSTEM);

    if (this.userRole !== "ETAXSUPERADMIN" && this.userRole !== "SUPERADMIN") {
      this.router.navigate(["home"]);
      return;
    }
  }
  checkCaseID(event) {
    this.caseId = event.target.value.match(/[0-9]*/)[0];
  }

  async searchErrorCode() {
    if (!this.caseId) {
      this.ErrorMsg(errMsg.errorCaseID);
      return;
    }
    const req = {
      storeBu: this.userBu,
      storeLoc: this.userLoc,
      userSource: this.userSource,
      userId: this.userID,
      caseId: this.caseId,
    };
    console.log("====== req search error log =======", req);
    try {
      this.apiService
        ._post(this.apiService.apiUrl + this.apiService.searchLog, req)
        .then((res) => {
          console.log("====== res search error log =======", res);
          if (res.statusCode === 200) {
            _setStorage(STORAGE.DATA_LOG_ETAX, res["data"]);
            this.router.navigate(["/backoffice/log-etax-detail"]);
          } else {
            this.ErrorMsg(res.statusMessage);
          }
        });
    } catch (error) {
      // this.ErrorMsg(errMsg.error)
    }
  }
  async ErrorMsg(message: string) {
    let alert = await this.alert.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: BTN.ok,
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }
}
